import { search } from './searchService';
import { post, put, del } from './apiService';
import type { ClientCertification } from '../types/clientCertification';
import type { SearchParams } from '../types/search';

export async function searchClientCertifications(
  filter: { clientId?: string; certificationId?: string } = {},
  params: SearchParams = {},
): Promise<ClientCertification[]> {
  return search<ClientCertification>('/client-certification/search', filter, params);
}

export async function createClientCertification(data: {
  clientId: string;
  certificationId: string;
  order: number;
}): Promise<ClientCertification> {
  return post<ClientCertification>('/client-certification', data);
}

export async function updateClientCertification(
  id: string,
  data: Partial<ClientCertification>,
): Promise<ClientCertification> {
  return put<ClientCertification>(`/client-certification/${id}`, data);
}

export async function deleteClientCertification(id: string): Promise<void> {
  return del<void>(`/client-certification/${id}`);
}
